<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            {{$t('form.iad-reservation.informations_rdv')}}
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <template v-if="selected">
                    <div class="text-xs font-bold">
                        <div>
                            <span class="font-light">{{$t('form.iad-reservation.nom')}}: </span><span class="font-bold">{{selected.name}}</span>
                        </div>
                        <div>
                            <span class="font-light">{{$t('form.iad-reservation.email')}}: </span><span class="font-bold">{{selected.email}}</span>
                        </div>
                        <div>
                            <span class="font-light">{{$t('form.iad-reservation.telephone')}}: </span><span class="font-bold">{{selected.tel}}</span>
                        </div>
                        <div>
                            <span class="font-light">{{$t('form.iad-reservation.date')}}: </span><span class="font-bold">{{selected.date}}</span>
                        </div>
                        <div>
                            <span class="font-light">{{$t('form.iad-reservation.moment_de_la_journee')}}: </span><span class="font-bold">{{selected.timeOfDay.label}}</span>
                        </div>
                    </div>
                </template>
            </template>

            <template v-slot:open>
                <!-- Informations de contact -->
                <h2 class="text-xl font-bold">{{$t('form.iad-reservation.informations_de_contact')}}</h2>
                <hr class="my-3">

                <template v-if="refreshFormData">
                    <sav-input class="w-full mb-3" :label="$t('form.iad-reservation.nom')" type="text" v-model="name" />
                    <sav-input class="w-full mb-3" :label="$t('form.iad-reservation.email')" type="email" v-model="email" />
                    <sav-input class="w-full mb-3" :label="$t('form.iad-reservation.telephone')" type="tel" v-model="tel" />
                </template>

                <!-- Lieu de rdv -->
                <h2 class="mt-10 text-xl font-bold">{{$t('form.iad-reservation.lieu_de_rdv')}}</h2>
                <hr class="my-3">

                <template v-if="refreshFormData">
                    <template v-if="!editAddress && newAddress">
                        {{newAddress.fullAddress}}
                        <button @click="editAddress = true">
                            <i class="ml-2 text-blue-500 cursor-pointer fas fa-pen"></i>
                        </button>
                    </template>
                    <template v-else>
                        <div class="flex">
                            <sav-address-input :placeholder="$t('form.iad-reservation.rechercher_une_adresse')" class="grow mr-3" @get="changeAddress" />
                            <button @click="editAddress = false">
                                <i class="ml-2 text-red-500 cursor-pointer fas fa-times"></i>
                            </button>
                        </div>
                    </template>
                </template>

                <!-- Date de rendez-vous -->
                <h2 class="mt-10 text-xl font-bold">{{$tt('Date de rendez-vous souhaitée')}}</h2>
                <hr class="my-3">

                <template v-if="refreshFormData">
                    <sav-input class="w-full mb-3" :label="$t('form.iad-reservation.date')" type="date" :meta="{disabledDays: [0]}" :min="minDate" v-model="date" />
                    <sav-input class="w-full mb-3" :label="$t('form.iad-reservation.moment_de_la_journee')" type="select" v-model="timeOfDay" :options="{
                        label: 'label',
                        values: [
                            {label: 'Matin', value: 'matin'},
                            {label: 'Après-midi', value: 'apres-midi'},
                            {label: 'Toute la journée', value: 'journee'},
                        ]
                        }"
                    />
                </template>

                <button class="mt-2 px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-green-600 border-green-700 hover:bg-green-700 rounded-xl" :disabled="loading" @click="end" test-id="btn-submit">
                    Valider
                </button>

                <!-- <sav-form
                v-if="data"
                :data-src="data"
                :callback="end"
                :id="$options.name"
                /> -->
            </template>
        </sav-fold-card>  
    </div>
</template>

<script>
import moment from 'moment'
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'iad-reservation',
    extends: FormCardExtension,

    data() {
        return {
            dataCase: null,
            user: null,
            refreshFormData: true,

            name: null,
            email: null,
            tel: null,
            date: null,
            timeOfDay: null,

            editAddress: false,
            newAddress: null,

            loading: false
        }
    },

    computed: {
        phoneNumber () {
            let phoneLocalStorage = this.$formTool.getFormData(this.$options.name)
            if (phoneLocalStorage) {
                return phoneLocalStorage.tel
            }
            return this.user.tel != '0' ? this.user.tel : null
        },

        minDate() {
            return moment().add(1, 'days').format('YYYY-MM-DD')
        }
    },

    methods: {
        async init() {
            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = await this.getNextBlock()
                this.emitChange()
            }

            this.user = await apiService.getUser()
            this.name = this.selected && this.selected.name ? this.selected.name : this.user.nom + ' ' + this.user.prenom
            this.email = this.selected && this.selected.email ? this.selected.email : this.user.mail
            this.tel = this.selected && this.selected.tel ? this.selected.tel : this.phoneNumber
            this.date = this.selected && this.selected.date ? this.selected.date : null
            this.timeOfDay = this.selected && this.selected.timeOfDay ? this.selected.timeOfDay : null
            this.newAddress = this.$formTool.getFormData('client-address')
            this.newAddress.adresse1 = this.newAddress.address1
            this.newAddress.adresse2 = this.newAddress.address2
            this.refreshFormData = false
            this.$nextTick(() => {
                this.refreshFormData = true
            })
        },

        async end() {
            let emptyValues = !this.name || !this.email || !this.tel || !this.date || !this.timeOfDay
            this.loading = true
            if (!emptyValues) {
                let response = await apiService.post('sendrdv', {
                    id_case: this.dataCase.id_case,
                    id_conso: this.$crypto.decrypt(localStorage.getItem('client_id')),
                    nom: this.name,
                    mail: this.email,
                    tel: this.tel,
                    date_rdv: moment(this.date, 'DD/MM/YYYY').format('YYYY-MM-DD') + ' ' + this.timeOfDay.value,
                    adresse1: this.newAddress.adresse1,
                    adresse2: this.newAddress.adresse2,
                    cp: this.newAddress.cp,
                    ville: this.newAddress.ville,
                })

                const storageData = {
                    name: this.name,
                    email: this.email,
                    tel: this.tel,
                    date: this.date,
                    timeOfDay: this.timeOfDay
                }
                this.$formTool.addFormData(this.$options.name, storageData)
                this.nextBlock = await this.getNextBlock()
                if (this.selected) {
                    this.$emit('update', this.$options.name)
                }
                this.selected = JSON.parse(JSON.stringify(storageData))
            } else {
                this.$toast.error('Merci de remplir tout les champs')
            }
                this.loading = false

        },

        async getNextBlock() {
            let responseAmount = await apiService.post('get_amount', {
                id_case: JSON.parse(this.$formTool.getFormData('set-case')).id_case
            })

            if (responseAmount.data.posts.post.montant_total > 0 && this.$formTool.getFormData('proc').type_garantie == 'hors_garantie') {
                return this.$formTool.blockData(this.$options.name).next.withoutWarranty
            } else {
               return this.$formTool.blockData(this.$options.name).next.warranty
            }
        },  

        getFromLabel(label) {
            // return this.$formTool.getFormData(this.$options.name) ? this.$formTool.getFormData(this.$options.name).find(el => el.label == label).value : null
        },

        changeAddress(address) {
            this.newAddress = {
                fullAddress: address.formatted_address,
                adresse1: address.address_components[0].long_name + ' ' + address.address_components[1].long_name,
                adresse2: null,
                cp: address.address_components[6].long_name,
                ville: address.address_components[2].long_name,
                longitude: address.geometry.location.lat(),
                latitude: address.geometry.location.lng()
            }
            this.editAddress = false
            console.log(this.newAddress);
        }
    },

    mounted() {
        this.init()
        this.dataCase = JSON.parse(this.$formTool.getFormData('set-case'))
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/procedure/Components/IadReservationCard.vue